import { gql } from '@apollo/client';

export const updateFeaturedCourses = gql`
  mutation updateFeaturedCourses($input: MutateFeaturedCoursesInput!) {
    updateFeaturedCourses(input: $input) {
      id
      name {
        languageCode
        languageId
        value
      }
    }
  }
`;

export const updateDomain = gql`
  mutation updateDomain($input: DomainInput!) {
    updateDomain(input: $input) {
      id
      domain
      name
      currency
      languages {
        code
      }
      defaultLanguage {
        code
      }
    }
  }
`;
